// Copyright 2016 Sorama B.V.

import { HttpResponseMessage } from "aurelia-http-client";
import { HttpResponseMessageError } from "errors/HttpResponseMessageError";

export class Repository {
    public onError(error: HttpResponseMessage): never {
        throw HttpResponseMessageError.fromHttpResponseMessage(error);
    }
}
